module.exports = __webpack_public_path__ + "img/60_60.8adf6910.png";